module.exports = __webpack_public_path__ + "static/media/left_arrow.b01e3f3b.svg";